module.exports = __webpack_public_path__ + "img/view.951f9a86.svg";